import React from 'react'

interface HighlightTextProps {
  text: string
  searchQuery: string
  className?: string
}

const HighlightText: React.FC<HighlightTextProps> = ({
  text,
  searchQuery,
  className,
}) => {
  if (!searchQuery || !searchQuery.trim()) {
    return <span className={className}>{text}</span>
  }

  // Экранируем специальные символы регулярных выражений
  const escapedQuery = searchQuery.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

  // Создаем регулярное выражение для поиска (без учета регистра)
  const regex = new RegExp(`(${escapedQuery})`, 'gi')

  // Разбиваем текст на части
  const parts = text.split(regex)

  return (
    <span className={className}>
      {parts.map((part, index) => {
        // Проверяем, является ли часть совпадением
        const isMatch = regex.test(part)

        return isMatch ? (
          <mark
            key={index}
            style={{
              backgroundColor: '#ffeb3b',
              color: '#000',
              padding: '0 2px',
              borderRadius: '2px',
              fontWeight: 'bold',
            }}
          >
            {part}
          </mark>
        ) : (
          <span key={index}>{part}</span>
        )
      })}
    </span>
  )
}

export default HighlightText
